
        var result = require("!!../../../../node_modules/css-loader/index.js!./member-whatsapp-community.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/member-whatsapp-community/member-whatsapp-community.component.css
// module id = 615
// module chunks = 0